import React from 'react';

import {
  IconButton as IconButtonTPA,
  IconButtonProps,
} from '@wix/wix-ui-tpa/cssVars';
import {
  OverridableComponent,
  OverridableComponentProps,
} from 'wui/OverridableComponent';

export { IconButtonSkins, IconButtonThemes } from '@wix/wix-ui-tpa/cssVars';

export interface IIconButtonProps extends Omit<IconButtonProps, 'innerRef'> {}

export const IconButton = React.forwardRef(
  (props: OverridableComponentProps<IIconButtonProps, 'button'>, ref) => {
    const { ...rest } = props;

    // @ts-expect-error
    return <IconButtonTPA innerRef={handleRef} {...rest} />;

    // ui-tpa 🤷‍♂️
    function handleRef(el: HTMLButtonElement) {
      if (typeof ref === 'function') {
        ref(el);
      } else if (ref) {
        // @ts-expect-error
        ref.current = el?.wrappedComponentRef?.innerComponentRef || null;
      }
    }
  },
) as OverridableComponent<IIconButtonProps, 'button'>;

IconButton.displayName = 'wui/IconButton';
